<script>
export const pageName = 'admin-insurance-checker';
export const pageRoute = '/admin/insurance-checker';
export const title = 'Insurance Checker'
export const requireAdmin = true;
import { queries } from '../../js/lib/functions.js';
import { hideLoading, showLoading } from '../../js/utils/loading.js';

export default {
	data() {
		return {
			surname: '',
			number: '',

			result: false,
			status: '',
			membership: '',
			expiryDate: ''
		}
	},

	methods: {
		check: async function(e) {
			showLoading();

			let result = await queries.users.account.queryBMFA({ 
				surname: this.surname,
				number: this.number
			});

			this.result = true;
			this.status = result.result.status;
			this.membership = result.result.membership;
			this.expiryDate = result.result.expiryDate;

			hideLoading();
		}
	}
}

</script>
<template>
	<div class="container py-5">
		<div class="row justify-content-center">
			<div class="col-12 col-lg-8">
				<h1 class="display-4 text-center mb-3">Insurance Checker</h1>
				<p class="text-muted text-center mb-5">Query the BMFA</p>
				<div class="card">
					<div class="card-body">
						<form @submit.prevent="upload">
							<fieldset class="mb-4">
								<div class="row">
									<div class="col">
										<div class="form-group mb-0">
											<label>BMFA Number</label>
											<input type="text" class="form-control" ref="bmfaNumber" pattern="[0-9]+" v-model="number" required placeholder="e.g. 123456" />
											<span class="invalid-feedback"></span>
										</div>
									</div>
									<div class="col">
										<div class="form-group mb-0">
											<label>Surname</label>
											<input type="text" class="form-control" ref="bmfaSurname" v-model="surname" required placeholder="e.g. Smith" />
											<span class="invalid-feedback"></span>
										</div>
									</div>
								</div>
							</fieldset>

							<button @click.prevent="check" type="submit" class="btn btn-primary">Check <span class="fe fe-shield"></span></button>
						</form>
					</div>
				</div>
				<div v-if="result" class="card">
					<div class="card-body">
						<div class="row text-center">
							<div class="col">
								{{ status }}
							</div>
							<div class="col">
								{{ membership }}
							</div>
							<div class="col">
								{{ expiryDate }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
